module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sorting"
  }, [_c('ui-button', {
    staticClass: "sort-btn",
    attrs: {
      "disabled": _vm.keyFor == _vm.sort && _vm.direction == 'desc',
      "icon": "keyboard_arrow_down"
    },
    on: {
      "click": function($event) {
        _vm.changeOrder(_vm.keyFor, 'desc')
      }
    }
  }), _vm._v(" "), _c('ui-button', {
    staticClass: "sort-btn",
    attrs: {
      "disabled": _vm.keyFor == _vm.sort && _vm.direction == 'asc',
      "icon": "keyboard_arrow_up"
    },
    on: {
      "click": function($event) {
        _vm.changeOrder(_vm.keyFor, 'asc')
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2550c26a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pagination/Sorting.vue
// module id = 234
// module chunks = 0